import {FindIntent} from "../components/snippet/snippet";

let hasBeenClickedBefore: boolean = false;

export default function showModalSimilars(
    id: string | undefined,
    pageViewId: string | undefined,
    sectionId: string,
    findIntent: FindIntent
) {
    const isDesktop = existsDataProperty("data-device", "desktop");
    const similarModal = document.getElementById('similar-modal');
    const shouldShowSimilarsPopup = !hasBeenClickedBefore && isDesktop && similarModal;

    if (shouldShowSimilarsPopup) {
        getHtmlForSimilarAdsPopup(id, 6, pageViewId, sectionId, findIntent)
            .then(response => {
                if (response.status == 200) {
                    response.text().then(text => {
                        similarModal.innerHTML = text;
                        similarModal.style.display = 'block';
                        registerSimilarAdsPopupEvents();
                        hasBeenClickedBefore = true;
                    });
                }
            });
    }
}

function existsDataProperty(property: string, value: string) {
    return document.querySelector(`div[${property}=${value}]`);
}

function registerSimilarAdsPopupEvents ()  {
    const closeIcon = document.getElementById("similar-modal__wrapper__header__close");
    const closeButton = document.getElementById("similar-modal__wrapper__footer__close");
    if (closeIcon && closeButton) {
        registerSimilarAdsPopupCloseEvents([closeIcon, closeButton]);
    }
}

function registerSimilarAdsPopupCloseEvents(elements: HTMLElement[]) {
    elements.map(element => element.addEventListener('click', hideSimilarAdsPopup));
}

function hideSimilarAdsPopup() {
    const modalWrapper = document.getElementById('similar-modal');
    if (modalWrapper) {
        modalWrapper.style.display = 'none';
    }
}

function getHtmlForSimilarAdsPopup(
    id: string | undefined,
    numberOfAds: number,
    pageViewId: string | undefined,
    sectionId: string | undefined,
    findIntent: FindIntent
) {
    const ids = Array.from(document.querySelectorAll('[data-listingId]')).map(e => e.getAttribute('data-listingId'))
    const idsParam = ids == null ? '' : ids.join(',')

    const params: {} = {
        id: id,
        number: numberOfAds,
        currentOrigin: sectionId,
        pageViewId: pageViewId,
        ids: idsParam,
        ...findIntent
    }

    const urlParams = new URLSearchParams(params);

    return fetch(`/internal/mitula/serp/similar-modal?${urlParams}`, {
        method: 'GET',
    });
}
